(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    class ScrollToTop {
    constructor() {
      this.button = document.querySelector('[data-scroll-to-top]');
      this.init();
    }

    init() {
      if (!this.button) return;

      this.button.addEventListener('click', this.scrollToTop.bind(this));
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ScrollToTop());
  } else {
    new ScrollToTop();
  }
  } catch(e) { console.error(e); }
})();

})();
